module.exports = __webpack_public_path__ + "static/media/aboutMeImage.c0c54019.jpg";